@if (isCXOne) {
    <cv-expanded-summary-cxone [moduleKey]="moduleKey" [moduleManager]="moduleManager" />
} @else {
    <cv-expanded-summary-pm [moduleKey]="moduleKey" [moduleManager]="moduleManager" />
}